import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Platform } from '@ionic/angular';

import { FeatureService } from '../firebase/feature.service';

export const MobileWebGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Promise<boolean | UrlTree> | boolean | UrlTree => {

    const platform = inject(Platform);
    const router = inject(Router);
    const featureService = inject(FeatureService);

    return new Promise(async (resolve, reject) => {
        const sessionGuard = sessionStorage.getItem('mobileWebGuard');
        if (sessionGuard === null) {
            if (!featureService.isDesktop && platform.is('mobile')) {
                router.navigate(['/mobile-web-prompt', { requestedPath: state.url }]);
            }
            sessionStorage.setItem('mobileWebGuard', 'true');
        }
        resolve(true);
    });
}